// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";            // for authentication
import { getFirestore } from "firebase/firestore";  // for database
import { getStorage } from "firebase/storage";      // for file storage

const firebaseConfig = {
  apiKey: "AIzaSyBxpv0vElhkAsbFmrLHgyXZRdyDKpRJ2mo",
  authDomain: "nexora-4394e.firebaseapp.com",
  projectId: "nexora-4394e",
  storageBucket: "nexora-4394e.firebasestorage.app",
  messagingSenderId: "730859888295",
  appId: "1:730859888295:web:c05adc5c081eb130c9c582",
  measurementId: "G-TLYXZVTYEH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services (optional)
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
